import type {
  ApiConfig,
  FeishuSSOLoginParams,
  FeishuSSOLoginResult,
  RefreshTokenResult,
  WhitelistConfig,
} from "./types";
import {
  requestFeishuSSOLogin as authRequestFeishuSSOLogin,
  requestRefresh as authRequestRefresh,
  requestUserInfo as authRequestUserInfo,
} from "@jt-home/jt-auth-tools";

/** 固定认证接口配置，只保留路径和请求方式。 */
export const apiConfig: ApiConfig = {
  refreshToken: {
    method: "POST",
    path: "/PSIGW/RESTListeningConnector/PSFT_HR/C_SRCH_OUT_AUTH_REFRESH.v1/",
  },
  getUserInfo: {
    method: "POST",
    path: "/PSIGW/RESTListeningConnector/PSFT_HR/C_SRCH_EMP_BASE_INFO.v1/",
  },
  ssoLogin: {
    method: "POST",
    path: "/PSIGW/RESTListeningConnector/PSFT_HR/C_FEISHU_SSO_LOGIN.v1/",
  },
};

/** 这些路径需要强制走根 `/api`，保持旧行为不变。 */
export const forceRootBasePaths = [
  apiConfig.refreshToken.path,
  apiConfig.getUserInfo.path,
  apiConfig.ssoLogin.path,
];

/** 不挂 token、也不走 refresh 的白名单，兼容旧拦截逻辑。 */
export const layerWhitelist: Required<WhitelistConfig> = {
  noTokenPaths: [apiConfig.refreshToken.path, apiConfig.ssoLogin.path],
  skipRefreshPaths: [apiConfig.refreshToken.path, apiConfig.ssoLogin.path],
};

/** 固定认证接口已经下沉到 auth-tools，这里只保留兼容出口。 */
export async function requestRefresh(
  refreshToken: string,
): Promise<RefreshTokenResult> {
  return authRequestRefresh(refreshToken);
}

/** 固定认证接口已经下沉到 auth-tools，这里只保留兼容出口。 */
export async function requestUserInfo(): Promise<unknown> {
  return authRequestUserInfo();
}

/** 固定认证接口已经下沉到 auth-tools，这里只保留兼容出口。 */
export async function requestFeishuSSOLogin(
  params: FeishuSSOLoginParams,
): Promise<FeishuSSOLoginResult["data"]> {
  return authRequestFeishuSSOLogin(params);
}
